module.exports = __webpack_public_path__ + "img/pic14.85085e78.jpg";